/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import AppLoading from "expo-app-loading";
import { Asset } from "expo-asset";
import * as Font from "expo-font";
import { useState } from "react";

export interface IApploader {
    assets: any[];
    fonts: any;
}

export const useAppLoader = ({ assets, fonts }: IApploader) => {
    const [isReady, setReady] = useState<boolean>(false);

    const cacheResource = async () => {
        await downloadAssets();
        await downloadFonts();
    };

    const downloadAssets = async () => {
        if (assets && Array.isArray(assets)) {
            assets.map(async (asset) => {
                await Asset.loadAsync(asset);
            });
        }
    };

    const downloadFonts = async () => {
        if (fonts) {
            await Font.loadAsync(fonts);
        }
    };

    return {
        AppLoading,
        cacheResource,
        isReady,
        setReady,
    };
};
